// Utility class exposing methods to check FeatureGate & ChangeGates
export class GateUtils {
    constructor(hostcallbacks) {
        this.hostCallbacks = hostcallbacks;
    }
    isFeatureEnabled(featureName, defaultValue = false, scope = 'None') {
        return this.hostCallbacks && this.hostCallbacks.isFeatureEnabled
            ? this.hostCallbacks.isFeatureEnabled('Microsoft.Office.AugLoop.' + featureName, scope)
                .catch(() => Promise.resolve(defaultValue))
            : Promise.resolve(defaultValue);
    }
    isChangeGateEnabled(changeGateName) {
        if (this.hostCallbacks && this.hostCallbacks.isChangeGateEnabled) {
            return this.hostCallbacks.isChangeGateEnabled(changeGateName);
        }
        return Promise.resolve(false);
    }
}
//# sourceMappingURL=gate-utils.js.map